module.exports = __webpack_public_path__ + "img/BS33.24ad7bc8.svg";